import { createContext } from 'react';
import { FilterFormContextProps } from './FilterForm.types';

const FilterFormContext = createContext<
  FilterFormContextProps<any> | undefined
>(undefined);

export default FilterFormContext;
